// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { pluralize } from '@/utilities/pluralize';
import { ReactElement } from 'react';

const COMBINED_SUFFIX = 'Some items already existed and were combined.';

/**
 * Builds the success toast content shown after a bundle apply.
 * Surfaces that auto-sum duplicate SKUs pass combined=true when an existing
 * row's quantity was increased instead of a new row appending; physical-only
 * surfaces pass skippedCount when members were dropped (a service member, or
 * appends that would exceed the surface's row cap).
 */
export function buildBundleAppliedToast(options: {
  lineCount: number;
  bundleName: string;
  combined?: boolean;
  skippedCount?: number;
}): ReactElement {
  const skipped = options.skippedCount ?? 0;
  return (
    <span>
      Added {pluralize(options.lineCount, { singular: 'line' })} from{' '}
      {options.bundleName}.{options.combined ? ` ${COMBINED_SUFFIX}` : ''}
      {skipped > 0
        ? ` ${pluralize(skipped, { singular: 'item' })} couldn't be added.`
        : ''}
    </span>
  );
}
